import React from 'react';
import classnames from 'classnames';

import { useShowcaseState } from './context';

const ShowcaseItems = ({ Component, items }) => {
  const { activeSection } = useShowcaseState();

  return items.map((item, index) => {
    const isActive = item === activeSection;

    return (
      <div
        className={classnames({ hidden: !isActive, block: isActive })}
        key={index}
      >
        <Component {...item} isFeatured />
      </div>
    );
  });
};

export default ShowcaseItems;
